import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/scan2pay/Nayax_logo.png'
import _imports_1 from '../../assets/images/scan2pay/Tiba-white.png'


const _withScopeId = n => (_pushScopeId("data-v-63288f89"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col",
    style: {"height":"6px","background-color":"#e0e0e0"}
  })
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "nayax_link_list_con" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"nayax_social_wrap\" data-v-63288f89><div class=\"nayax_logo_con\" data-v-63288f89><img src=\"" + _imports_0 + "\" style=\"height:23px;margin-right:20px;\" data-v-63288f89><div class=\"yellowseparator\" data-v-63288f89></div><img src=\"" + _imports_1 + "\" style=\"height:36px;margin-left:20px;\" data-v-63288f89></div></div>", 1)
const _hoisted_9 = { class: "c_tag_wrap scan2pay" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "© ", -1))
const _hoisted_11 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  props: {
    termsAndConditions: null,
    privacyPolicy: null,
    contactUs: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: __props.contactUs,
              target: "_blank"
            }, _toDisplayString(_ctx.$t('Contact Us')), 9, _hoisted_5)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: __props.termsAndConditions,
              target: "_blank"
            }, _toDisplayString(_ctx.$t('terms & conditions')), 9, _hoisted_6)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: __props.privacyPolicy,
              target: "_blank"
            }, _toDisplayString(_ctx.$t('privacy policy')), 9, _hoisted_7)
          ])
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("h5", {
        innerHTML: _ctx.$t('all rights reserved')
      }, null, 8, _hoisted_11)
    ])
  ], 512))
}
}

})